var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              { staticClass: "m-b-xs-20" },
              [
                _c(
                  "ak-button",
                  { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("arrow_left"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Ga terug")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ak-panel__header ak-panel__header--info ak-panel__header--small",
                  },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _c("i", { staticClass: "fa fa-list-ul" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Kandidaat-fiche")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                !_vm.loading
                  ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c("tbody", [
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Datum aanvraag")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm._f("date-relative")(
                                    _vm.candidate.dateCreated
                                  )
                                ) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("BTW-nummer")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.vat) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Naam van de organisatie")) + ":"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.title) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Publieke naam")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.titlePublic) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Adresgegevens van de zaak")) +
                                  ":"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.address) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Website")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm.candidate.website
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.candidate.website,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.candidate.website) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("E-mailadres")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm.candidate.email
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:" + _vm.candidate.email,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.candidate.email) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Publiek e-mailadres")) + ":"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm.candidate.emailPublic
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" + _vm.candidate.emailPublic,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.candidate.emailPublic) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Type handelaar")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.typeTitle) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Categorie")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.collection ? _vm.collection.title : ""
                                ) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Motivatie")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", {
                            staticClass: "ak-table-column",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.candidate.motivation.replace(
                                  /(?:\r\n|\r|\n)/g,
                                  "<br>"
                                )
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Andere kortingssites?")) + ":"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.candidate.otherWebsitesForDisplay) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _c("i", { staticClass: "muted" }, [
                              _vm._v(_vm._s(_vm.$t("Bestand")) + ":"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm.candidate.uploadFilePath
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.candidate.uploadFilePath,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("Download bestand")) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ak-panel__header ak-panel__header--info  ak-panel__header--small",
                  },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _c("i", { staticClass: "fa fa-certificate" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Exclusief voordeel")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                !_vm.loading
                  ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.offers, function (offer) {
                          return _c(
                            "tr",
                            { key: offer.id, staticClass: "ak-table-row" },
                            [
                              _c(
                                "td",
                                { staticClass: "ak-table-column" },
                                [
                                  _c("ak-chip", {
                                    attrs: {
                                      title: _vm.$options.filters.datetime(
                                        offer.dateCreated
                                      ),
                                      size: "small",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "p-1",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        offer.offer.replace(
                                          /(?:\r\n|\r|\n)/g,
                                          "<br>"
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  {
                    class:
                      "ak-panel__header ak-panel__header--small candidate-status candidate-status-" +
                      _vm.candidate.status,
                    staticStyle: { "": "root {--panel-header-background: red" },
                  },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.candidate.statusTitle) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ak-panel__body ak-panel__body--small" },
                  [
                    _c("ak-button", {
                      attrs: {
                        title: _vm.ratingAdministrator
                          ? _vm.$t("Beoordeling aanpassen")
                          : _vm.$t("Beoordeling toevoegen"),
                        size: "small",
                        colorMode: "secondary",
                      },
                      on: { click: _vm.onClickRatingButton },
                    }),
                    _vm._v(" "),
                    [
                      _c("ak-button", {
                        attrs: {
                          title: _vm.$t("Beslissing ingeven"),
                          size: "small",
                          colorMode: "secondary",
                        },
                        on: { click: _vm.onClickDecisionButton },
                      }),
                      _vm._v(" "),
                      _vm.supplier
                        ? _c("ak-button", {
                            attrs: {
                              title: _vm.$t("Bekijk leverancier"),
                              size: "small",
                              colorMode: "secondary",
                            },
                            on: { click: _vm.onClickViewSupplierButton },
                          })
                        : _c("ak-button", {
                            attrs: {
                              title: _vm.$t("Leverancier aanmaken"),
                              size: "small",
                              colorMode: "secondary",
                            },
                            on: { click: _vm.onClickCreateSupplierButton },
                          }),
                    ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ak-panel__header ak-panel__header--info ak-panel__header--small",
                  },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Beoordelingen")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                !_vm.loading && _vm.ratings.length
                  ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c(
                        "tbody",
                        [
                          _c("tr", { staticClass: "ak-table-column" }, [
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Datum"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Beheerder"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Handelaar"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Exclusief voordeel"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.ratings, function (rating) {
                            return _c(
                              "tr",
                              {
                                key: rating.id,
                                staticClass: "ak-table-column",
                              },
                              [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("date")(rating.dateCreated)
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(rating.administratorName) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "ak-table-column" },
                                  [
                                    _c(
                                      "ak-tooltip",
                                      {
                                        attrs: {
                                          disabled: rating.commentsCandidate,
                                          body: rating.commentsCandidate,
                                        },
                                      },
                                      [
                                        _c("span", {
                                          class:
                                            "rating-candidate-" +
                                            rating.administratorId,
                                          domProps: {
                                            innerHTML: _vm._s(
                                              rating.ratingCandidateAsHtml
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "ak-table-column" },
                                  [
                                    _c(
                                      "ak-tooltip",
                                      {
                                        attrs: {
                                          disabled: rating.commentsOffer,
                                          body: rating.commentsOffer,
                                        },
                                      },
                                      [
                                        _c("span", {
                                          class:
                                            "rating-candidate-" +
                                            rating.administratorId,
                                          domProps: {
                                            innerHTML: _vm._s(
                                              rating.ratingOfferAsHtml
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  : _c(
                      "div",
                      { staticClass: "ak-panel__body ak-panel__body--small" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Nog geen beoordelingen")) +
                            "\n                    "
                        ),
                      ]
                    ),
              ]
            ),
            _vm._v(" "),
            !_vm.loading && _vm.ratings.length
              ? _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__header ak-panel__header--info ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _c("i", { staticClass: "fa fa-history" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Historiek")) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c(
                        "tbody",
                        [
                          _c("tr", { staticClass: "ak-table-column" }, [
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Datum"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Beheerder"))),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "ak-table-column" }, [
                              _vm._v(_vm._s(_vm.$t("Omschrijving"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.history, function (historyItem) {
                            return _c(
                              "tr",
                              {
                                key: historyItem.id,
                                staticClass: "ak-table-column",
                              },
                              [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("datetime")(
                                          historyItem.dateCreated
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(historyItem.administratorName) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", {
                                  staticClass: "ak-table-column",
                                  domProps: {
                                    innerHTML: _vm._s(historyItem.description),
                                  },
                                }),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "childview" },
        on: { formSaved: _vm.onFormSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }